import React from 'react'

const PaymentSuccess = ({}) => { 
  
  return (
    <div>
      <div  style={{
            position: 'absolute', 
            left: '50%', 
            top: '50%',
            transform: 'translate(-50%, -50%)'
        }} >
      <img style={{ borderRadius: '2rem' }} src="icon_animated_check_circle.gif" alt="logo" />
      </div>
    </div>
  )
}

export default PaymentSuccess